import { params } from "../vars/params";
import { config } from "../../config";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const setResize = (): void => {
  if (!params.isSp) {
    params.bW = document.documentElement.clientWidth;
    params.bH = document.documentElement.clientHeight;
    params.isSp = params.bW < config.breakPoint;
    params.isTall = params.bW < params.bH * 0.5;
    params.scrolled = window.scrollY > params.bH * 0.8;
    if (params.scrolled) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
    ScrollTrigger.refresh();
  }
};
